@if (searchLoad) {
  <div class="search-query-container modify-search">
    <mat-card class="card-margin">
      @if (IsInEditMode && IsLoaded ) {
        <div class="">
          @for (searchParam of searchParms; track searchParam; let index = $index) {
            <div class="row remove-bot-margin search-form-section">
              <!-- Dropdowns fieldName Displayed -->
              <!-- Super Admin for Approval queue-->
              @if (isEditOrganization && isAdminandClubUser && childData == 'approvalQueue') {
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [disabled]="index == 0" (selectionChange)="getSelectedFieldName($event)" name="parent.fieldDisplayName" [(value)]="searchParam.fieldName" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (item of searchBuilderResponses; track item) {
                        <mat-option [value]="item.fieldName">
                          {{item.fieldDisplayName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- Super Admin for Member search-->
              @if (isEditOrganization && isAdminandClubUser && childData == 'memberSearch') {
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select (selectionChange)="getSelectedFieldName($event)" name="parent.fieldDisplayName" [(value)]="searchParam.fieldName" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (item of searchBuilderResponses; track item) {
                        <mat-option [value]="item.fieldName">
                          {{item.fieldDisplayName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- Account approver for Approval queue-->
              @if (isEditOrganization && isAccountApproverUser && childData == 'approvalQueue') {
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [disabled]="index == 0" (selectionChange)="getSelectedFieldName($event)" name="parent.fieldDisplayName" [(value)]="searchParam.fieldName" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (item of searchBuilderResponses; track item) {
                        <mat-option [value]="item.fieldName">
                          {{item.fieldDisplayName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- Account approver for Member search-->
              @if (isEditOrganization && isAccountApproverUser && childData == 'memberSearch') {
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select (selectionChange)="getSelectedFieldName($event)" name="parent.fieldDisplayName" [(value)]="searchParam.fieldName" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (item of searchBuilderResponses; track item) {
                        <mat-option [value]="item.fieldName">
                          {{item.fieldDisplayName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- Military/Bgca Member Search -->
              @if ( (isMilitaryOfficial || isBgcaAlliance ) && !isCEO && isEditOrganization && childData == 'memberSearch') {
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [disabled]="index == 0" (selectionChange)="getSelectedFieldName($event)" name="parent.fieldDisplayName" [(value)]="searchParam.fieldName" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (item of searchBuilderResponses; track item) {
                        <mat-option [value]="item.fieldName">
                          {{item.fieldDisplayName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- Military/Bgca Approval Queue -->
              @if ( (isMilitaryOfficial || isBgcaAlliance )  && !isEditOrganization && childData == 'approvalQueue') {
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [disabled]="index ==  0 || index ==  1" (selectionChange)="getSelectedFieldName($event)" name="parent.fieldDisplayName" [(value)]="searchParam.fieldName" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (item of searchBuilderResponses; track item) {
                        <mat-option [value]="item.fieldName">
                          {{item.fieldDisplayName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- CEO Member Search -->
              @if (!isEditOrganization && childData == 'memberSearch') {
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [disabled]="index == 0" (selectionChange)="getSelectedFieldName($event)" name="parent.fieldDisplayName" [(value)]="searchParam.fieldName" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (item of searchBuilderResponses; track item) {
                        <mat-option [value]="item.fieldName">
                          {{item.fieldDisplayName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- CEO Approval Queue -->
              @if (isEditOrganization && childData == 'approvalQueue' && !isAdminandClubUser && !isAccountApproverUser) {
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [disabled]="index == 0 || index == 1" (selectionChange)="getSelectedFieldName($event)" name="parent.fieldDisplayName" [(value)]="searchParam.fieldName" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (item of searchBuilderResponses; track item) {
                        <mat-option [value]="item.fieldName">
                          {{item.fieldDisplayName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- Dod Approval Queue -->
              @if ( isDodUser && !isEditOrganization && childData == 'approvalQueue') {
                <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [disabled]="index ==  0 || index ==  1" (selectionChange)="getSelectedFieldName($event)" name="parent.fieldDisplayName" [(value)]="searchParam.fieldName" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (item of searchBuilderResponses; track item) {
                        <mat-option [value]="item.fieldName">
                          {{item.fieldDisplayName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              <!-- Control Displayed for to Choose or Enter Values -->
              <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 mobile-bottom-margin">
                <!-- Text box to enter values -->
                @if (getUserInputControlType(searchParam.fieldName) =='Textbox' ) {
                  <mat-form-field appearance="fill" class="w-100">
                    <input matInput type="text" [(ngModel)]="searchParam.value" (keyup.enter)="search()">
                  </mat-form-field>
                }
                <!-- Organization Dropdown -->
                @if (isAdminandClubUser && isEditOrganization && getUserInputControlType(searchParam.fieldName) =='Dropdown' && searchParam.fieldName == 'PrimaryOrgGlobalID'  ) {
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [(value)]="searchParam.value" panelClass="myPanelClass" [formControl]="bankCtrl"
                      [disableOptionCentering]="true" (selectionChange)='getSelectedOrganization($event.value)'>
                      <mat-option>
                        <ngx-mat-select-search [formControl]="bankFilterCtrl"
                          appearance="fill" placeholderLabel="Type the keyword..."
                          noEntriesFoundLabel="'Searching your organization'">
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (ctrlItem of myOrganization; track ctrlItem) {
                        <mat-option [value]="ctrlItem.Key">
                          {{ctrlItem.Value}}
                        </mat-option>
                      }
                    </mat-select>
                    <!-- <img src='/assets/icons/search_icon.png' (click)="focusOutFunction()" class="search-textbox-icon"> -->
                  </mat-form-field>
                }
                @if (isAccountApproverUser && !isAdminandClubUser && isEditOrganization && getUserInputControlType(searchParam.fieldName) =='Dropdown' && searchParam.fieldName == 'PrimaryOrgGlobalID'  ) {
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [(value)]="searchParam.value" panelClass="myPanelClass" [formControl]="bankCtrl"
                      [disableOptionCentering]="true" (selectionChange)='getSelectedOrganization($event.value)'>
                      <mat-option>
                        <ngx-mat-select-search [formControl]="bankFilterCtrl"
                          appearance="fill" placeholderLabel="Type the keyword..."
                          noEntriesFoundLabel="'Searching your organization'">
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (ctrlItem of myOrganization; track ctrlItem) {
                        <mat-option [value]="ctrlItem.Key">
                          {{ctrlItem.Value}}
                        </mat-option>
                      }
                    </mat-select>
                    <!-- <img src='/assets/icons/search_icon.png' (click)="focusOutFunction()" class="search-textbox-icon"> -->
                  </mat-form-field>
                }
                @if (isDodUser && !isEditOrganization && getUserInputControlType(searchParam.fieldName) =='Dropdown' && searchParam.fieldName == 'PrimaryOrgGlobalID'  ) {
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [(value)]="searchParam.value" panelClass="myPanelClass" [formControl]="bankCtrl"
                      [disableOptionCentering]="true" (selectionChange)='getSelectedOrganization($event.value)'>
                      <mat-option>
                        <ngx-mat-select-search [formControl]="bankFilterCtrl"
                          appearance="fill" placeholderLabel="Type the keyword..."
                          noEntriesFoundLabel="'Searching your organization'">
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (ctrlItem of myOrganization; track ctrlItem) {
                        <mat-option [value]="ctrlItem.Key">
                          {{ctrlItem.Value}}
                        </mat-option>
                      }
                    </mat-select>
                    <!-- <img src='/assets/icons/search_icon.png' (click)="focusOutFunction()" class="search-textbox-icon"> -->
                  </mat-form-field>
                }
                <!-- Other Dropdown -->
                @if (getUserInputControlType(searchParam.fieldName) =='Dropdown' && searchParam.fieldName != 'PrimaryOrgGlobalID' ) {
                  <mat-form-field appearance="fill" class="w-100">
                    <mat-select [(value)]="searchParam.value" panelClass="myPanelClass"
                      [disableOptionCentering]="true">
                      @for (ctrlItem of getUserInputDropdownControlValues(searchParam.fieldName); track ctrlItem) {
                        <mat-option [value]="ctrlItem.Key">
                          {{ctrlItem.Value}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                <!-- disabled Organization TextBox -->
                @if ( !isDodUser && !isEditOrganization && searchParam.fieldName == 'PrimaryOrgGlobalID') {
                  <mat-form-field appearance="fill" class="w-100 dod">
                    <input matInput type="text" [(ngModel)]="orgName" [disabled]="true">
                  </mat-form-field>
                }
                @if (childData == 'approvalQueue' && !isDodUser && !isAdminandClubUser && !isAccountApproverUser && isEditOrganization && searchParam.fieldName == 'PrimaryOrgGlobalID') {
                  <mat-form-field appearance="fill" class="w-100 admin">
                    <input matInput type="text" [(ngModel)]="orgName" [disabled]="true">
                  </mat-form-field>
                }
              </div>
              <div class="col-lg-5 col-md-12 bottom-btn-section">
                @if (index !=0 && searchParms.length != (index +0) && childData == 'memberSearch') {
                  <span>
                    <button mat-button matPrefix mat-icon-button class="add-delete-btn margin-right-24 delete-icon top-margin delete-btn-margin"
                      (click)="removeParam(index)">
                    </button>
                  </span>
                }
                @if (index !=0 && index !=0 && searchParms.length != (index +0) && isAdminandClubUser && !isDodUser && childData == 'approvalQueue') {
                  <span>
                    <button mat-button matPrefix mat-icon-button class="add-delete-btn margin-right-24 delete-icon top-margin delete-btn-margin"
                      (click)="removeParam(index)">
                    </button>
                  </span>
                }
                @if (index > 1 && searchParms.length != (index +0) && isAdminandClubUser && isDodUser && childData == 'approvalQueue') {
                  <span>
                    <button mat-button matPrefix mat-icon-button class="add-delete-btn margin-right-24 delete-icon top-margin delete-btn-margin"
                      (click)="removeParam(index)">
                    </button>
                  </span>
                }
                @if (index !=0 && index !=1 && searchParms.length != (index +0) && !isAdminandClubUser && childData == 'approvalQueue') {
                  <span>
                    <button mat-button matPrefix mat-icon-button class="add-delete-btn margin-right-24 delete-icon top-margin delete-btn-margin"
                      (click)="removeParam(index)">
                    </button>
                  </span>
                }
                @if (index != parameterLength && searchParms.length == (index +1)) {
                  <span>
                    <button mat-button matPrefix mat-icon-button class="add-delete-btn add-icon margin-right-24 top-margin"
                      [disabled]="addSearchLimitReached" (click)="addParam()">
                    </button>
                  </span>
                }
                @if (searchParms.length == (index +1)) {
                  <span class="search-clear-btn">
                    <button mat-button matPrefix mat-icon-button (click)="search()"
                      class="primary-small-btn-blue margin-right-24  top-margin">
                      Search
                    </button>
                    <button mat-button matPrefix mat-icon-button class="primary-small-btn-blue margin-right-24 top-margin"
                      (click)="clearAllSearch()">
                      Clear All
                    </button>
                  </span>
                }
              </div>
            </div>
          }
          @if (childData === 'memberSearch' && isCPO) {
            <div class="row">
              <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                <mat-checkbox name="IsAppAllow" [(ngModel)]="IsAppAllow" class="checkbox"
                  (change)="isAppAllow($event)"
                appearance="fill">Do you want to include role?</mat-checkbox>
              </div>
              <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                <mat-select [disabled]="!IsAppAllow" placeholder="Select Application Roles" name="application" [(ngModel)]="applicationSelected">
                  @for (item of applicationDropDownData; track item) {
                    <mat-option [value]="item.id">
                      {{item.displayName}}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
          }
        </div>
      }
      @if (!IsInEditMode && IsLoaded) {
        <div class="form-row serchBox search-section">
          <div class="form-group col-md-12 align-items-center margin-bottom-16 searched-content modify-search-section">
            @if (showSearchButton) {
              <div class="">
                <button mat-button matPrefix mat-icon-button (click)="modifySearch()" class="primary-btn-blue">
                  Modify Search
                </button>
              </div>
            }
            <!-- Search parameters displayed after search is clicked -->
            @for (item of searchParms; track item) {
              <span>
                <span class="mr-3">
                  <b>{{ getSearchedDisplayFieldInfo(item) }}: </b> {{ item.value != null && item.value.indexOf("|")>0 ? formatSearchFilterresult(item.value.split("|")[1]) : item.value }}
                </span>
              </span>
            }
          </div>
        </div>
      }
    </mat-card>
  </div>
}
